import { SELECIONAR_PERFIS } from '../types'

export default function selecionarPerfis (perfis) {
  return {
    type: SELECIONAR_PERFIS,
    payload: perfis
  }
}
